import classNames from 'classnames';
import { useEffect } from 'react';
import RichText from '@/components/atoms/rich-text/rich-text';
import Typography from '@/components/atoms/typography/typography';
import Lightbox from '@/components/utilities/lightbox/lightbox';
import styles from './star-details-modal.module.scss';

export interface StarDetailsModalProps {
  /** The class name to apply */
  className?: string;
  /** The description of the modal */
  description?: Content.Components['ExtraItemDto']['description'];
  /** The headline of the modal */
  headline?: Content.Components['ExtraItemDto']['headline'];
  /** Indicates whether the modal is open. */
  isOpen?: boolean;
  /** The callback to handle the close event. */
  onClose: () => void;
}

const StarDetailsModal = ({
  className,
  description,
  headline,
  isOpen = false,
  onClose,
}: StarDetailsModalProps) => {
  useEffect(() => {
    if (!window) return;

    const handleKeydown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose && onClose();
      }
    };

    window.addEventListener('keydown', handleKeydown);

    return () => {
      window.removeEventListener('keydown', handleKeydown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <Lightbox
      className={classNames(styles.component, className)}
      isCentered
      isOpen={isOpen}
      onClose={onClose}
      wrapperClassName={styles.lightboxWrapper}
    >
      <div className={styles.lightboxInnerWrapper}>
        {headline && (
          <Typography
            className={styles.headline}
            tag="h3"
            tagStyle="headingMedium"
          >
            {headline}
          </Typography>
        )}

        {description && (
          <RichText className={styles.description} text={description} />
        )}
      </div>
    </Lightbox>
  );
};

StarDetailsModal.displayName = 'StarDetailsModal';

export default StarDetailsModal;
